export enum AuthEnvironment {
    PPE,    // Pre-Production Environment
    Prod    // Production
}

export interface IAuthenticationProvider {
    Authenticate(): void;
    GetAccessToken(resource: string): Promise<string>;
    GetAuthEnvironment(): AuthEnvironment;
}